var map = {
	"./+login/login.module": [
		"./src/app/+login/login.module.ts",
		"login-login-module"
	],
	"./+register/register.module": [
		"./src/app/+register/register.module.ts",
		"register-register-module"
	],
	"./pages/administrator-page/agende/verificare/verificare-agende.module": [
		"./src/app/pages/administrator-page/agende/verificare/verificare-agende.module.ts",
		"pages-administrator-page-agende-verificare-verificare-agende-module"
	],
	"./pages/administrator-page/aula/crea/crea-aula.module": [
		"./src/app/pages/administrator-page/aula/crea/crea-aula.module.ts",
		"pages-administrator-page-aula-crea-crea-aula-module"
	],
	"./pages/administrator-page/aula/list/list-aule.module": [
		"./src/app/pages/administrator-page/aula/list/list-aule.module.ts"
	],
	"./pages/administrator-page/aula/modifica/modifica-aula.module": [
		"./src/app/pages/administrator-page/aula/modifica/modifica-aula.module.ts",
		"pages-administrator-page-aula-modifica-modifica-aula-module"
	],
	"./pages/administrator-page/corso-laurea/crea/crea-corso-laurea.module": [
		"./src/app/pages/administrator-page/corso-laurea/crea/crea-corso-laurea.module.ts",
		"pages-administrator-page-corso-laurea-crea-crea-corso-laurea-module"
	],
	"./pages/administrator-page/corso-laurea/list/list-corsi-laurea.module": [
		"./src/app/pages/administrator-page/corso-laurea/list/list-corsi-laurea.module.ts"
	],
	"./pages/administrator-page/corso-laurea/modifica/modifica-corso-laurea.module": [
		"./src/app/pages/administrator-page/corso-laurea/modifica/modifica-corso-laurea.module.ts",
		"pages-administrator-page-corso-laurea-modifica-modifica-corso-laurea-module"
	],
	"./pages/administrator-page/funzionalita/carica-voti-placement/carica-voti-placement.module": [
		"./src/app/pages/administrator-page/funzionalita/carica-voti-placement/carica-voti-placement.module.ts"
	],
	"./pages/administrator-page/funzionalita/carica-voti-prova-finale/carica-voti-prova-finale.module": [
		"./src/app/pages/administrator-page/funzionalita/carica-voti-prova-finale/carica-voti-prova-finale.module.ts"
	],
	"./pages/administrator-page/funzionalita/download-studenti-placement/download-studenti-placement.module": [
		"./src/app/pages/administrator-page/funzionalita/download-studenti-placement/download-studenti-placement.module.ts"
	],
	"./pages/administrator-page/funzionalita/genera-gruppi-studio/genera-gruppi-studio.module": [
		"./src/app/pages/administrator-page/funzionalita/genera-gruppi-studio/genera-gruppi-studio.module.ts"
	],
	"./pages/administrator-page/funzionalita/registrazione-sistema/registrazione-sistema.module": [
		"./src/app/pages/administrator-page/funzionalita/registrazione-sistema/registrazione-sistema.module.ts"
	],
	"./pages/administrator-page/gruppo-studio/calendario/calendario-gruppo-studio.module": [
		"./src/app/pages/administrator-page/gruppo-studio/calendario/calendario-gruppo-studio.module.ts",
		"pages-administrator-page-gruppo-studio-calendario-calendario-gruppo-studio-module"
	],
	"./pages/administrator-page/gruppo-studio/crea/crea-gruppo-studio.module": [
		"./src/app/pages/administrator-page/gruppo-studio/crea/crea-gruppo-studio.module.ts",
		"pages-administrator-page-gruppo-studio-crea-crea-gruppo-studio-module"
	],
	"./pages/administrator-page/gruppo-studio/dettaglio/dettaglio-gruppo-studio.module": [
		"./src/app/pages/administrator-page/gruppo-studio/dettaglio/dettaglio-gruppo-studio.module.ts",
		"pages-administrator-page-gruppo-studio-dettaglio-dettaglio-gruppo-studio-module"
	],
	"./pages/administrator-page/gruppo-studio/list/list-gruppi-studio.module": [
		"./src/app/pages/administrator-page/gruppo-studio/list/list-gruppi-studio.module.ts"
	],
	"./pages/administrator-page/gruppo-studio/modifica/modifica-gruppo-studio.module": [
		"./src/app/pages/administrator-page/gruppo-studio/modifica/modifica-gruppo-studio.module.ts",
		"pages-administrator-page-gruppo-studio-modifica-modifica-gruppo-studio-module"
	],
	"./pages/administrator-page/laboratorio-lezione-tutoraggio/appelli/appelli-laboratori-lezione-tutoraggio.module": [
		"./src/app/pages/administrator-page/laboratorio-lezione-tutoraggio/appelli/appelli-laboratori-lezione-tutoraggio.module.ts"
	],
	"./pages/administrator-page/laboratorio-lezione-tutoraggio/calendario/calendario-laboratorio.module": [
		"./src/app/pages/administrator-page/laboratorio-lezione-tutoraggio/calendario/calendario-laboratorio.module.ts",
		"pages-administrator-page-laboratorio-lezione-tutoraggio-calendario-calendario-laboratorio-module"
	],
	"./pages/administrator-page/laboratorio-lezione-tutoraggio/crea/crea-laboratorio-lezione-tutoraggio.module": [
		"./src/app/pages/administrator-page/laboratorio-lezione-tutoraggio/crea/crea-laboratorio-lezione-tutoraggio.module.ts",
		"pages-administrator-page-laboratorio-lezione-tutoraggio-crea-crea-laboratorio-lezione-tutoraggio-module"
	],
	"./pages/administrator-page/laboratorio-lezione-tutoraggio/dettaglio/dettaglio-laboratorio-lezione-tutoraggio.module": [
		"./src/app/pages/administrator-page/laboratorio-lezione-tutoraggio/dettaglio/dettaglio-laboratorio-lezione-tutoraggio.module.ts",
		"pages-administrator-page-laboratorio-lezione-tutoraggio-dettaglio-dettaglio-laboratorio-lezione-tutoraggio-module"
	],
	"./pages/administrator-page/laboratorio-lezione-tutoraggio/list/list-laboratori-lezione-tutoraggio.module": [
		"./src/app/pages/administrator-page/laboratorio-lezione-tutoraggio/list/list-laboratori-lezione-tutoraggio.module.ts"
	],
	"./pages/administrator-page/laboratorio-lezione-tutoraggio/modifica/modifica-laboratorio-lezione-tutoraggio.module": [
		"./src/app/pages/administrator-page/laboratorio-lezione-tutoraggio/modifica/modifica-laboratorio-lezione-tutoraggio.module.ts",
		"pages-administrator-page-laboratorio-lezione-tutoraggio-modifica-modifica-laboratorio-lezione-tutoraggio-module"
	],
	"./pages/administrator-page/language-level/crea/crea-language-level.module": [
		"./src/app/pages/administrator-page/language-level/crea/crea-language-level.module.ts",
		"pages-administrator-page-language-level-crea-crea-language-level-module"
	],
	"./pages/administrator-page/language-level/list/list-language-level.module": [
		"./src/app/pages/administrator-page/language-level/list/list-language-level.module.ts"
	],
	"./pages/administrator-page/language-level/modifica/modifica-language-level.module": [
		"./src/app/pages/administrator-page/language-level/modifica/modifica-language-level.module.ts",
		"pages-administrator-page-language-level-modifica-modifica-language-level-module"
	],
	"./pages/administrator-page/profilo/modifica/modifica-profilo.module": [
		"./src/app/pages/administrator-page/profilo/modifica/modifica-profilo.module.ts",
		"pages-administrator-page-profilo-modifica-modifica-profilo-module"
	],
	"./pages/administrator-page/prova-finale/crea/crea-prova-finale.module": [
		"./src/app/pages/administrator-page/prova-finale/crea/crea-prova-finale.module.ts",
		"pages-administrator-page-prova-finale-crea-crea-prova-finale-module"
	],
	"./pages/administrator-page/prova-finale/list/list-prove-finali.module": [
		"./src/app/pages/administrator-page/prova-finale/list/list-prove-finali.module.ts"
	],
	"./pages/administrator-page/prova-finale/modifica/modifica-prova-finale.module": [
		"./src/app/pages/administrator-page/prova-finale/modifica/modifica-prova-finale.module.ts",
		"pages-administrator-page-prova-finale-modifica-modifica-prova-finale-module"
	],
	"./pages/administrator-page/self-study/crea-categoria/crea-categoria.module": [
		"./src/app/pages/administrator-page/self-study/crea-categoria/crea-categoria.module.ts",
		"common",
		"pages-administrator-page-self-study-crea-categoria-crea-categoria-module"
	],
	"./pages/administrator-page/self-study/crea-documento/crea-documento.module": [
		"./src/app/pages/administrator-page/self-study/crea-documento/crea-documento.module.ts",
		"common",
		"pages-administrator-page-self-study-crea-documento-crea-documento-module"
	],
	"./pages/administrator-page/self-study/list-categorie/list-categorie.module": [
		"./src/app/pages/administrator-page/self-study/list-categorie/list-categorie.module.ts",
		"common",
		"pages-administrator-page-self-study-list-categorie-list-categorie-module"
	],
	"./pages/administrator-page/self-study/list-documenti/list-documenti.module": [
		"./src/app/pages/administrator-page/self-study/list-documenti/list-documenti.module.ts",
		"common",
		"pages-administrator-page-self-study-list-documenti-list-documenti-module"
	],
	"./pages/administrator-page/self-study/modifica-categoria/modifica-categoria.module": [
		"./src/app/pages/administrator-page/self-study/modifica-categoria/modifica-categoria.module.ts",
		"common",
		"pages-administrator-page-self-study-modifica-categoria-modifica-categoria-module"
	],
	"./pages/administrator-page/self-study/modifica-documento/modifica-documento.module": [
		"./src/app/pages/administrator-page/self-study/modifica-documento/modifica-documento.module.ts",
		"common",
		"pages-administrator-page-self-study-modifica-documento-modifica-documento-module"
	],
	"./pages/administrator-page/sessione-ola/crea/crea-sessione-ola.module": [
		"./src/app/pages/administrator-page/sessione-ola/crea/crea-sessione-ola.module.ts",
		"pages-administrator-page-sessione-ola-crea-crea-sessione-ola-module"
	],
	"./pages/administrator-page/sessione-ola/list/list-sessioni-ola.module": [
		"./src/app/pages/administrator-page/sessione-ola/list/list-sessioni-ola.module.ts"
	],
	"./pages/administrator-page/sessione-ola/modifica/modifica-sessione-ola.module": [
		"./src/app/pages/administrator-page/sessione-ola/modifica/modifica-sessione-ola.module.ts",
		"pages-administrator-page-sessione-ola-modifica-modifica-sessione-ola-module"
	],
	"./pages/administrator-page/studente/crea/crea-studente.module": [
		"./src/app/pages/administrator-page/studente/crea/crea-studente.module.ts",
		"pages-administrator-page-studente-crea-crea-studente-module"
	],
	"./pages/administrator-page/studente/dettaglio/dettaglio-studente.module": [
		"./src/app/pages/administrator-page/studente/dettaglio/dettaglio-studente.module.ts",
		"pages-administrator-page-studente-dettaglio-dettaglio-studente-module"
	],
	"./pages/administrator-page/studente/list/list-studenti.module": [
		"./src/app/pages/administrator-page/studente/list/list-studenti.module.ts",
		"pages-administrator-page-studente-list-list-studenti-module"
	],
	"./pages/administrator-page/studente/modifica/modifica-studente.module": [
		"./src/app/pages/administrator-page/studente/modifica/modifica-studente.module.ts",
		"pages-administrator-page-studente-modifica-modifica-studente-module"
	],
	"./pages/administrator-page/utente/crea/crea-utente.module": [
		"./src/app/pages/administrator-page/utente/crea/crea-utente.module.ts",
		"pages-administrator-page-utente-crea-crea-utente-module"
	],
	"./pages/administrator-page/utente/list/list-utenti.module": [
		"./src/app/pages/administrator-page/utente/list/list-utenti.module.ts"
	],
	"./pages/administrator-page/utente/modifica/modifica-utente.module": [
		"./src/app/pages/administrator-page/utente/modifica/modifica-utente.module.ts",
		"pages-administrator-page-utente-modifica-modifica-utente-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;